import {
  MDSButton,
  MDSButtonVariant,
  MDSButtonSlotName,
  MDSIcon,
  MDSIconKind,
  MDSButtonSize,
} from "@/mds";
import { INoteObservable } from "@/store/note";
import { observer } from "mobx-react-lite";

type Props = {
  note: INoteObservable;
  onToggleOrganizeIsOpen: () => void;
  renderTrigger?: (trigger: React.ReactNode) => React.ReactNode;
};

export const OrganizeNoCollections = observer(
  ({ note, onToggleOrganizeIsOpen, renderTrigger }: Props) => {
    const organizeButton = (
      <MDSButton
        variant={MDSButtonVariant.Subtle}
        size={MDSButtonSize.Small}
        onClick={() => {
          if (!note.id) return;

          onToggleOrganizeIsOpen();
        }}
      >
        <MDSIcon kind={MDSIconKind.Collection} slot={MDSButtonSlotName.LeftIcon} />
        Organize
      </MDSButton>
    );

    return renderTrigger ? renderTrigger(organizeButton) : organizeButton;
  }
);
